import React, { useState, useEffect } from 'react';
import { Grid, Tab, Tabs } from '@mui/material';
import Holiday_calendar from '../Holiday Calendar/Holiday';
import Circular from '../Circular/Circular';
import Issue from '../issueDisclosure/IssueDis';
import { withStyles, styled } from "@mui/styles";
// import Issue_disclosures from '../circular/issue_disclosures';
import { useLocation } from "react-router-dom";
// import DocumentMeta from 'react-document-meta';
import styles from './MainCircular.module.css'; // Import the CSS module

// const meta = {
//     title: 'Holiday calendar | Circular | Issue disclosures | Bulletin | BullForce',
//     description: 'Bullforce Holiday Calendar: Plan ahead with our NSE, BSE trading holiday schedule. Stay informed on market closures for effective stock and bond trading. Bullforce Circular: Stay informed with the latest NSE, BSE circulars. Get essential updates on trading, compliance, and demat account regulations. Bullforce Issue Disclosures: Access detailed disclosures on stock, bond, and IPO issues. Stay compliant with NSE, BSE regulations for informed trading decisions. Bullforce Bulletin: Stay updated with the latest trading news, market insights, and stock analysis. Access expert reports on demat accounts, stocks, and more.',
//     canonical: 'https://bullforce.co/holiday_calendar, https://bullforce.co/circular,  https://bullforce.co/issue_disclosures, https://bullforce.co/bulletin',
//     meta: {
//         charset: 'utf-8',
//         name: {
//             keywords: 'demat, holiday, circular, issue, bulletin, disclosures, calendar bullforce, plans, NSE, BSE, CDSL, trading, stocks, bonds, mutual funds, gold, IPOs, SEBI, registered, Wealth'
//         }
//     }
// };

const styles1 = theme => ({
    buttonlabel: {
        textTransform: 'none !important',
        color: '#000000 !important',
        fontFamily: 'Inter400 !important',
        fontSize: 'calc(15px + var(--font-delta)) !important',
        "&:hover": {
            cursor: 'pointer'
        },
        "@media only screen and (max-device-width: 700px)": {
            fontSize: 'calc(14px + var(--font-delta)) !important',
            width: "150px !important"
        },

    },
    buttonlabel_bold: {
        textTransform: 'none !important',
        color: '#000000 !important',
        fontFamily: 'Inter700',
        fontSize: 'calc(15px + var(--font-delta)) !important',
        fontWeight: '600 !important',
    },
    buttonlabel_bold1: {
        color: '#000000 !important',
        fontFamily: 'Inter700',
        fontSize: 'calc(15px + var(--font-delta)) !important',
        fontWeight: '600 !important',
        "&:hover": {
            color: "#00ACFE !important",
            cursor: 'pointer'
        },
    },
    p_card: {
        width: '90%',
        "@media only screen and (max-device-width: 480px)": {
            width: '100%',
        }
    },
    p_tab_back: {
        background: '#F7F9FA !important',
        "@media only screen and (max-device-width: 480px)": {
            background: '#F7F9FA !important',
            '& .MuiTabs-scrollButtons': {
                color: 'white !important',
            },
        },
    },
    p_tab_back1: {
        background: '#ffffff',
        height: 'auto',
        padding: '32px',
        borderRadius: '8px',
        marginTop: '15px',
        "@media only screen and (max-device-width: 480px)": {
            background: '#F7F9FA !important',
            borderRadius: '0px',
            paddingTop: '15px'
        }
    },
    main_tab: {
        "@media only screen and (max-device-width: 480px)": {
            paddingTop: '90px !important',
            height: 'auto',
        }
    }
});

const MainCircular = ({ classes }) => {
    const [tabValue, setTabValue] = useState(0);
    const location = useLocation();

    // useEffect(() => {
    //     document.body.style.backgroundColor = "#F2F2F2";
    //     if (window.innerWidth < 960) {
    //         document.body.style.backgroundColor = "#1B2636";
    //     }

    //     const path = window.location.pathname;
    //     if (path === "/holiday_calendar") setTabValue(0);
    //     if (path === "/circular") setTabValue(1);
    //     if (path === "/issue_disclosures") setTabValue(2);
    // }, []);

    useEffect(() => {
        // Update background color dynamically
        document.body.style.backgroundColor = window.innerWidth < 960 ? "#F2F2F2" : "#F2F2F2";

        // Set tab value based on the current route
        switch (location.pathname) {
            case "/holiday_calendar":
                setTabValue(0);
                break;
            case "/circular":
                setTabValue(1);
                break;
            case "/issue_disclosures":
                setTabValue(2);
                break;
            default:
                setTabValue(0);
                break;
        }

        // ✅ Scroll to the top whenever route changes
        window.scrollTo({ top: 0, behavior: "smooth" });

    }, [location.pathname]);
    const handleTabChange = (event, value) => {
        setTabValue(value);
    };

    return (
        <div className={styles.mainTab}>
            {/* <DocumentMeta {...meta} /> */}

            <Grid className={styles.tabGrid}>
                <Grid className={styles.tabCard}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        className={styles.tabBack}
                        TabIndicatorProps={{ style: { backgroundColor: "#F3D45E" } }}
                    >
                        <Tab
                            className={tabValue === 0 ? classes.buttonlabel_bold : classes.buttonlabel}
                            label="Holiday Calendar"
                        />

                        <Tab
                            className={tabValue === 1 ? classes.buttonlabel_bold : classes.buttonlabel}
                            label="Circular"
                        />

                        <Tab
                            className={tabValue === 2 ? classes.buttonlabel_bold : classes.buttonlabel}
                            label="Issue Disclosures"
                        />
                    </Tabs>

                    {tabValue === 0 && (
                        <div className={styles.tabSub}>
                            <Holiday_calendar />
                        </div>
                    )}
                    {tabValue === 1 && (
                        <main className={styles.tabSub}>
                            <Circular />
                        </main>
                    )}
                    {tabValue === 2 && (
                        <main className={styles.tabSub}>
                            <Issue />
                        </main>
                    )}
                </Grid>
            </Grid>
        </div>
    );
};

export default withStyles(styles1)(MainCircular);